module.exports = __webpack_public_path__ + "static/media/about_main.9de12f76.png";